import React from 'react';
import { Badge } from '@printdeal/ui-library';
import { FormattedMessage } from 'react-intl';

interface NewBadgeProps {
  variant: 'warning' | 'primary-outline';
}

const NewBadge = ({ variant }: NewBadgeProps) => (
  <div className="pd-inline">
    <Badge variant={variant} className="pd-ml-2"><FormattedMessage
      id="segmented.customer.badge.new"
      defaultMessage="New"
    />
    </Badge>
  </div>
);

export default NewBadge;
